<template>
    <div class="login-page">
        <!-- <div class="page-left">
            <div class="tip1">{{ $t('message.download.leadingExchange') }}</div>
            <div class="tip2">{{ $t('login-tip') }}</div>
        </div> -->

        <div class="img-l">
            <img src="@/assets/login/login_l.png" alt="" />
        </div>
        <div>
            <div class="relative">
                <div class="title">
                    {{ $t('message.user.loginT') }}
                </div>
                <div class="tip1">{{
                    $t('message.download.leadingExchange') +
                    ',' +
                    $t('login-tip')
                }}</div>
                <div>
                    <div class="flex m-b-24">
                        <button
                            v-for="item in deviceData"
                            :key="item.value"
                            class="device_item"
                            :class="{ is_active: is_active === item.value }"
                            @click="selectDevice(item)"
                        >
                            {{ item.name }}
                        </button>
                    </div>
                    <el-form
                        ref="loginForm"
                        :model="loginForm"
                        :rules="loginRules"
                        class="login_form"
                        label-position="left"
                        @submit.native.prevent
                    >
                        <div>
                            <div class="label_text">
                                {{
                                    is_active === 1
                                        ? $t('message.user.phoneNumber')
                                        : $t('message.user.emailA')
                                }}
                            </div>
                            <div class="flex m-b-21">
                                <area-code
                                    v-if="is_active === 1"
                                    :area-list="area_list"
                                    :is-filter="true"
                                    class="selCode"
                                    @updataArea="updataArea"
                                />
                                <el-form-item
                                    prop="username"
                                    class="flex-1"
                                    :rules="[
                                        {
                                            required: true,
                                            trigger: 'change',
                                            validator:
                                                is_active === 1
                                                    ? loginForm.area_code ===
                                                      '86'
                                                        ? validatePhone
                                                        : validateForeignPhone
                                                    : validateEmail
                                        }
                                    ]"
                                >
                                    <el-input
                                        ref="username"
                                        v-model.trim="loginForm.username"
                                        :placeholder="
                                            is_active === 1
                                                ? $t('message.user.inputPh')
                                                : $t('message.user.inputE')
                                        "
                                        name="username"
                                        :maxlength="is_active === 1 ? 13 : ''"
                                        @input="handleInput"
                                    />
                                </el-form-item>
                            </div>
                        </div>
                        <!-- <el-form-item prop="username"
          :class="{'user_input': is_active === 1}"
          :rules="[{ required: true, trigger: 'change', validator: is_active === 1 ? loginForm.area_code === '86' ? validatePhone : validateForeignPhone : validateEmail }]">
          <div class="label_text">{{is_active === 1 ? $t('message.user.phoneNumber') : $t('message.user.emailA')}}</div>
          <div style="display: flex;">
            <area-code v-if="is_active === 1" :areaList="area_list" @updataArea="updataArea"></area-code>
            <el-input
              ref="username"
              v-model.trim="loginForm.username"
              :placeholder="is_active === 1 ? $t('message.user.inputPh') : $t('message.user.inputE')"
              name="username"
              :maxlength="is_active === 1 ? 13 : ''"
              @input="handleInput"/>
          </div>
        </el-form-item> -->
                        <el-form-item
                            prop="password"
                            :rules="[
                                {
                                    required: true,
                                    trigger: 'change',
                                    message: $t('message.user.inputPass')
                                }
                            ]"
                        >
                            <div class="label_text">
                                {{ $t('message.user.password') }}
                            </div>
                            <div class="flex align-center">
                                <el-input
                                    :key="passwordType"
                                    ref="password"
                                    v-model.trim="loginForm.password"
                                    :type="passwordType"
                                    :placeholder="$t('message.user.inputPass')"
                                    name="password"
                                    @input="handleInput"
                                />
                                <span class="show_pwd" @click="showPwd">
                                    <i
                                        class="eye"
                                        :class="
                                            passwordType === 'password'
                                                ? 'eye_close'
                                                : 'eye_open'
                                        "
                                    />
                                </span>
                            </div>
                        </el-form-item>
                        <!-- :disabled="!isToLogin" -->
                        <el-button
                            class="login_btn"
                            :class="{ is_login: true }"
                            :loading="loading"
                            type="primary"
                            @click.native.prevent="showSafety"
                        >
                            {{ $t('message.user.login') }}
                        </el-button>
                        <div class="flex justify-between m-l-6">
                            <el-button
                                class="forget"
                                @click="$router.push({ name: 'Tips' })"
                            >
                                {{ $t('message.user.forgetP') }}？
                            </el-button>
                            <div class="no_account">
                                {{ $t('message.user.noAccount') }}？<router-link
                                    class="to_register"
                                    to="/register"
                                >
                                    {{ $t('message.user.toRegis') }}
                                </router-link>
                            </div>
                        </div>
                    </el-form>
                    <div
                        v-show="showQRCodeBox && !isAccountL"
                        class="qrcode_box"
                    >
                        <div v-if="!showExpired" class="w-p100 text-center">
                            <div
                                v-if="!showExpired && showQRCode"
                                v-loading="imgLoading"
                                class="w-175 h-175 m-lr-auto b-1-solid-black b-r-4"
                            >
                                <vue-qr
                                    class="b-r-8"
                                    :text="QRCodeLoginUrl"
                                    :size="173"
                                    :margin="11"
                                    color-dark="#181A20"
                                />
                            </div>
                            <el-image
                                v-if="!showQRCode"
                                class="w-140 h-140"
                                :src="img_src"
                                fit="cover"
                            />
                            <div
                                class="text-c808C9A font-16 ff-Regular"
                                :class="[showQRCode ? 'm-t-20' : 'm-t-41']"
                            >
                                {{
                                    showQRCode
                                        ? $t('message.user.openApp')
                                        : $t('message.user.confirmLogin')
                                }}
                            </div>
                        </div>
                        <div v-else class="w-p100 text-center">
                            <img
                                class="w-75 h-75 m-b-20"
                                src="@/assets/user/tips_icon_big.png"
                                alt=""
                            />
                            <div class="m-b-40 font-16 text-c808C9A ff-Regular">
                                {{ $t('message.user.qrcodeExp') }}
                            </div>
                            <el-button
                                class="update_qrcode"
                                @click="initQRLoginCode()"
                            >
                                {{ $t('message.user.updateQrcode') }}
                            </el-button>
                        </div>
                    </div>
                </div>
                <common-dialog
                    from="safety"
                    :title="dialog.safetyTitle"
                    :show-search="false"
                    :dialog-visible.sync="dialog.safetyVisible"
                    @handleClose="handleClose"
                >
                    <slider-bar
                        :log="true"
                        @validImg="validImg"
                        @close="onClose"
                    />
                </common-dialog>
            </div>
        </div>
        <div class="img-r">
            <img src="@/assets/login/login_r.png" alt="" />
        </div>
    </div>
</template>

<script>
import CommonDialog from '@/components/commomDialog';
import VueQr from 'vue-qr';
import SliderBar from '@/components/sliderBar';
import AreaCode from '@/components/areaCode';
import { mapState } from 'vuex';
import { defaultCountry } from '@/utils/country';
import { validateEmail, validatePhone, validateForeignPhone } from '@/utils'; // encryption --密码加密方法
import { setTime, removeTime } from '@/utils/auth';
export default {
    name: 'LoginBox',
    components: {
        VueQr,
        CommonDialog,
        SliderBar,
        AreaCode
    },
    data() {
        return {
            isAccountL: true,
            deviceData: [
                {
                    name: `${this.$t('message.user.email')}${this.$t(
                        'message.user.login'
                    )}`,
                    value: 2
                },
                {
                    name: `${this.$t('message.user.phone')}${this.$t(
                        'message.user.login'
                    )}`,
                    value: 1
                }
            ],
            is_active: 2,
            loginForm: {
                username: '', // 15678833362
                password: '', // Aa123456@@
                area_code: defaultCountry().area_code,
                area_logo: defaultCountry().area_logo
            },
            loginRules: {
                // password: [{ required: true, trigger: 'change', validator: validatePassword }]
            },
            validateEmail,
            validatePhone,
            validateForeignPhone,
            loading: false,
            passwordType: 'password',
            isToLogin: false,
            // 二维码刷新图片
            img_src: require('@/assets/user/success_icon.png'),
            QRCodeLoginUrl: '', // 二维码url地址
            showQRCode: false, // 是否显示二维码
            showQRCodeBox: false, // 是否显示扫描二维码登录方式
            showExpired: false, // 是否显示二维码过期遮罩层
            timer: null, // 初始定时器变量名为null
            user_code: null, // 判断用户扫码登录的UUID
            dialog: {
                areaTitle: this.$t('message.safeCenter.selectAreaCode'),
                safetyTitle: this.$t('message.buyCoins.securityVerification'),
                safetyVisible: false,
                forgetVisible: false
            },
            filterList: [],
            isUserFocus: false,
            isPassFocus: false,
            imgLoading: false
        };
    },
    computed: {
        ...mapState({
            area_list: state => state.user.country_list
        })
    },
    created() {
        this.loadCountryList();
    },
    destroyed() {
        this.end(); // 清除定时器
    },
    methods: {
        loadCountryList() {
            this.$store.dispatch('user/getCountry').then(() => {
                this.filterList = [...this.area_list];
            });
        },
        checkLoginType() {
            this.isAccountL = !this.isAccountL;
            if (!this.isAccountL) {
                // 初始化登录二维码
                this.initQRLoginCode();
            } else {
                this.end();
            }
        },
        // 获取二维码登录相关信息
        initQRLoginCode() {
            this.showQRCodeBox = true;
            this.imgLoading = true;
            this.showQRCode = true;
            this.$store.dispatch('user/getLoginQRCode').then(res => {
                this.imgLoading = false;
                this.QRCodeLoginUrl = res.secret; // 二维码URL
                this.showExpired = false;
                this.user_code = res.secret;
                // ==== 二维码获取成功 ====
                this.start();
            });
        },
        // 二维码登录结果轮询接口---开始
        start() {
            // 将定时器名字赋值到变量中
            if (!this.timer) {
                this.timer = setInterval(() => {
                    this.$store
                        .dispatch('user/checkUserLogin', this.user_code)
                        .then(response => {
                            // console.log(response)
                            const res = response.data;
                            if (response.status === 0) {
                                // 二维码失效 -1
                                this.end(); // 停止轮询
                                this.showExpired = true;
                            }
                            if (res.status == 1) {
                                // 登录中 1
                                this.showQRCode = false;
                            }
                            if (res.status == 2) {
                                // 登录成功 2
                                this.end(); // 停止轮询
                                this.$router.push('/'); // 跳转到主页
                            }
                        })
                        .catch(() => {
                            this.end(); // 停止轮询
                        });
                }, 3000);
            } else {
                this.end();
            }
        },
        // 二维码登录结果轮询接口---结束
        end() {
            clearInterval(this.timer);
            this.timer = null;
        },
        // 选择当前登录账号类型
        selectDevice(item) {
            this.is_active = item.value;
            this.$refs.loginForm.resetFields();
            this.handleInput();
        },
        // 弹窗关闭
        handleClose(from) {
            if (from === 'safety') {
                this.dialog.safetyVisible = false;
            }
        },
        // 选择某一个区号
        updataArea(item) {
            this.loginForm.area_logo = item.img;
            this.loginForm.area_code = item.area_code;
        },
        // 显示 || 隐藏密码
        showPwd() {
            if (this.passwordType === 'password') {
                this.passwordType = '';
            } else {
                this.passwordType = 'password';
            }
            this.$nextTick(() => {
                this.$refs.password.focus();
            });
        },
        // 忘记密码提示弹窗关闭
        forgetPassword() {
            this.dialog.forgetVisible = false;
            this.$router.push({ path: '/login/forget' });
        },
        // 立即登录按钮显示图形验证
        showSafety() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    // this.dialog.safetyVisible = true;

                    const filterParams = {};
                    if (this.is_active === 1) {
                        filterParams.phone = this.loginForm.username;
                    } else {
                        filterParams.email = this.loginForm.username;
                    }
                    filterParams.phone_area_code = this.loginForm.area_code;
                    // filterParams.password = encryption(this.loginForm.password)
                    filterParams.password = this.loginForm.password;
                    filterParams.login_type = this.is_active;
                    this.$store
                        .dispatch('user/login', filterParams)
                        .then(res => {
                            const query = {
                                login_type: this.is_active,
                                phoneAuth: res.is_phone_auth,
                                emailAuth: res.is_email_auth,
                                googleAuth: res.is_google_auth,
                                email: res.email_addr,
                                phone: res.phone_number,
                                emailPass: res.email_pass,
                                phonePass: res.phone_pass,
                                area_code: res.area_phone_code,
                                password: filterParams.password
                            };
                            sessionStorage.setItem(
                                'loginParams',
                                JSON.stringify(query)
                            );
                            // setTime('loginParamsSaveTime');
                            this.removeStorage();
                            this.$router.push({ path: '/' });
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        removeStorage() {
            sessionStorage.removeItem('loginParams');
            removeTime('loginParamsSaveTime');
            sessionStorage.removeItem('forgetParams');
            removeTime('forgetParamsSaveTime');
        },
        // 安全验证弹窗关闭
        onClose() {
            this.dialog.safetyVisible = false;
        },
        // 操作滑动后返回值，并传去后端验证
        validImg(movePercent, callback) {
            callback(false);
            this.dialog.safetyVisible = false;
            const filterParams = {};
            if (this.is_active === 1) {
                filterParams.phone = this.loginForm.username;
            } else {
                filterParams.email = this.loginForm.username;
            }
            filterParams.phone_area_code = this.loginForm.area_code;
            // filterParams.password = encryption(this.loginForm.password)
            filterParams.password = this.loginForm.password;
            filterParams.login_type = this.is_active;
            this.$store.dispatch('user/login', filterParams).then(res => {
                const query = {
                    login_type: this.is_active,
                    phoneAuth: res.is_phone_auth,
                    emailAuth: res.is_email_auth,
                    googleAuth: res.is_google_auth,
                    email: res.email_addr,
                    phone: res.phone_number,
                    emailPass: res.email_pass,
                    phonePass: res.phone_pass,
                    area_code: res.area_phone_code,
                    password: filterParams.password
                };
                sessionStorage.setItem('loginParams', JSON.stringify(query));
                setTime('loginParamsSaveTime');
                this.$router.push({ path: '/login/safeVerify' });
            });
        },
        handleInput() {
            if (this.is_active === 1) {
                this.loginForm.username = this.loginForm.username.replace(
                    /[^\d]/g,
                    ''
                );
            }
            if (this.loginForm.username && this.loginForm.password) {
                this.isToLogin = true;
            } else {
                this.isToLogin = false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
$text-color: #373c42;
.title {
    font-family: PingFang_Bold;
    color: $text-color;
    font-weight: 500;
    font-size: 32px;
    padding-bottom: 55px;
}
.img_logo {
    top: -18px;
    right: -20px;
}
.device_item {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #808c9a;
    padding: 10px 15px;
    border: none;
    background-color: transparent;
    font-family: PingFang_Medium;
    border-radius: 4px 4px 4px 4px;
    margin-right: 30px;
}
.is_active {
    font-family: PingFang_Bold;
    color: #fff;
    background: #ed683a;
    border-radius: 4px 4px 4px 4px;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
}
.login_form {
    .user_input {
        ::v-deep .el-form-item__error {
            margin-left: 135px;
        }
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .el-input {
        height: 52px;
        ::v-deep {
            .el-input__inner {
                color: $text-color !important;
                height: 100%;
                background: #fff;
                border-radius: 10px 10px 10px 10px;
                border: 1px solid #bbbbbb;
                &::placeholder {
                    font-size: 14px;
                    color: #808c9a;
                }
                &:hover {
                    border-color: $basicColor;
                }
            }
        }
    }
    .label_text {
        font-family: PingFang_Medium;
        font-weight: 500;
        color: #636b75;
        margin-bottom: 6px;
        font-size: 18px;
        line-height: 18px;
    }
    .forget {
        border: none;
        color: $basicColor;
        background-color: transparent;
        padding: 0;
        ::v-deep {
            & > span {
                font-family: PingFang_Regular;
            }
        }
    }
    .login_btn {
        width: 100%;
        height: 58px;
        background-color: #ED683A;
        border-radius: 4px;
        border: none;
        font-family: PingFang_Regular;
        color: #fff;
        margin-top: 200px;
        margin-bottom: 20px;
    }
    .is_login {
        background-color: $basicColor;
        color: $basicWhite;
    }
    .no_account {
        color: #808c9a;
        font-size: 14px;
        font-family: PingFang_Regular;
        .to_register {
            color: $basicColor;
            font-family: PingFang_Regular;
            &:hover {
                color: rgba($color: #31987a, $alpha: 0.8);
            }
        }
    }
}
.qrcode_box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    z-index: 2;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 46px 0 90px;
    background-color: rgba($color: #fff, $alpha: 0.9);
    .update_qrcode {
        height: 43px;
        width: 163px;
        background-color: $basicColor;
        color: #222326;
        font-family: PingFang_Regular;
    }
    ::v-deep {
        .el-loading-mask {
            background-color: #fff;
        }
    }
}

.login-page {
    width: 100%;
    display: flex;
    background: #fff;
    color: #000;
    align-items: center;
    justify-content: center;
    .page-left {
        flex: 1;
        background: url('@/assets/login/login-bgi.png') center center no-repeat;
        background-size: 90% 90%;
        .tip1 {
            font-weight: 600;
            font-size: 52px;
            color: $text-color;
            line-height: 61px;
            padding: 183px 0 5px 100px;
        }
        .tip2 {
            font-weight: 600;
            font-size: 22px;
            color: $text-color;
            line-height: 26px;
            padding-left: 100px;
        }
    }
    .relative {
        width: 600px;
        background: #fff;
        box-shadow: 0px 0px 30px 2px rgba(59, 59, 59, 0.15);
        border-radius: 40px;
        padding: 30px 50px;
        .title {
            font-weight: 600;
            font-size: 42px;
            color: #240900;
            text-align: center;
            padding-bottom: 5px;
        }
        .tip1 {
            text-align: center;
            font-weight: 400;
            font-size: 24px;
            color: #a1a1a1;
        }
        .device_item {
            flex: 1;
            margin-top: 50px;
        }
    }

    .img-l {
        > img {
            width: 560px;
            height: 550px;
        }
    }
    .img-r {
        > img {
            width: 560px;
            height: 550px;
        }
    }
}
</style>
<style lang="scss">
.tool_item {
    padding: 5px 5px 4px 6px;
    font-family: PingFang_Regular;
    margin-right: 23px !important;
    &.is-dark {
        color: #1a1f2a;
        background-color: rgba($color: $basicColor, $alpha: 1);
    }
    .popper__arrow {
        top: 8px !important;
        border-left-color: rgba($color: $basicColor, $alpha: 1) !important;
        border-width: 4px;
        right: -4px !important;
        &::after {
            display: none;
            border-left-color: rgba($color: $basicColor, $alpha: 1) !important;
        }
    }
}

.selCode {
    .container {
        border: 1px solid #bbbbbb;
        background: #fff;
        border-radius: 10px 10px 10px 10px;
        .m-r-9 {
            color: #373c42;
        }
        .el-icon-caret-bottom {
            color: #373c42;
        }
    }
}
</style>
